import "./ResultSchedule.html";
import "./ResultSchedule.scss";

import "./CalendarView/CalendarViewComponent";
import "./SchemeView/SchemeViewComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ResultScheduleComponentController from "./ResultScheduleComponentController";

export default class ResultScheduleComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            schedule: "<",
            showHeader: "=",
            timeZone: "<",
        };
        this.controller = ResultScheduleComponentController;
        this.templateUrl = "/App/Components/Forms/ResultSchedule/ResultSchedule.html";
    }
}

module("mmManagePortal").component("irResultSchedule", new ResultScheduleComponent());
